export default __webpack_public_path__ + "static/media/sunset.8672ce0e.jpg";